<!-- 電気契約情報 -->
<mat-card class="cur-card">
  <mat-card-header>
    <mat-card-title>契約情報</mat-card-title>
    <div>
      <mat-icon>contact_page</mat-icon>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>契約番号</mat-label>
        <input matInput id="firstSrvctrNo" value="{{urikakekinInfo.ctrInf01Dto.firstSrvctrNo}}"
          class="font-color-display-only" disabled />
      </mat-form-field>
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>契約名称</mat-label>
        <input matInput id="ctrAname" value="{{urikakekinInfo.ctrInf01Dto.ctrAname}}" class="font-color-display-only"
          disabled />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>契約者お客さま名</mat-label>
        <input matInput id="visitName" value="{{urikakekinInfo.ctrInf01Dto.visitName}}" class="font-color-display-only"
          disabled />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="90" fxFlex.lt-md="100">
        <mat-label>使用場所住所</mat-label>
        <input matInput id="emptoAddrInf" [value]=" urikakekinInfo.emptoInfDto.emptoAddrInfDto | billDispZyuusyo"
          class="font-color-display-only" disabled />
      </mat-form-field>
    </div>
  </mat-card-content>
</mat-card>